// fuzzyMatch.js
export const createFuzzyMatcher = (threshold = 0.8) => {
  // Levenshtein Distance calculation
  const levenshteinDistance = (str1, str2) => {
    const matrix = Array(str1.length + 1).fill(null)
      .map(() => Array(str2.length + 1).fill(null));

    for (let i = 0; i <= str1.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= str2.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= str1.length; i++) {
      for (let j = 1; j <= str2.length; j++) {
        const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost
        );
      }
    }

    return matrix[str1.length][str2.length];
  };

  // Calculate similarity score
  const calculateSimilarity = (str1, str2) => {
    const maxLength = Math.max(str1.length, str2.length);
    if (maxLength === 0) return 1.0;
    const distance = levenshteinDistance(str1, str2);
    return 1 - distance / maxLength;
  };

  // Return the matcher function
  return (input, target) => {
    const similarity = calculateSimilarity(input.toLowerCase(), target.toLowerCase());
    return similarity >= threshold;
  };
};